import React from 'react';
import clsx from 'clsx';
const SimpleSideMenuTemplate = ({
  title,
  description,
  classes = {},
  children
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: clsx('menu-section', classes.root && classes.root)
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx('section-title')
  }, /*#__PURE__*/React.createElement("span", null, title)), description && /*#__PURE__*/React.createElement("div", {
    className: clsx('section-description', classes.description && classes.description)
  }, description), children && /*#__PURE__*/React.createElement("div", {
    className: clsx('menu-items-container', classes.content && classes.content)
  }, children));
};
export default SimpleSideMenuTemplate;